import { useCallback } from 'react';

// Define the type for cookie options
interface CookieOptions {
  path?: string;
  maxAge?: number;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

const useSignupCookie = () => {

  const setCookie = useCallback(
    (name: string, value: string, options: CookieOptions = {}) => {
      let cookieString = `${name}=${value}`;

      if (options.path) {
        cookieString += `; path=${options.path}`;
      }
      if (options.maxAge !== undefined) {
        cookieString += `; max-age=${options.maxAge}`;
      }
      if (options.secure) {
        cookieString += `; Secure`;
      }
      if (options.sameSite) {
        cookieString += `; SameSite=${options.sameSite}`;
      }

      document.cookie = cookieString;
    },
    []
  );

  const getCookie = useCallback((name: string): string | null => {
    const cookies = document.cookie.split('; ');
    const found = cookies.find(cookie => cookie.startsWith(`${name}=`));
    if (!found) return null;
    return decodeURIComponent(found.split('=')[1]);
  }, []);

  const deleteCookie = useCallback((name: string, path = '/') => {
    document.cookie = `${name}=; path=${path}; max-age=0`;
  }, []);

  return { setCookie, getCookie, deleteCookie };
};

export default useSignupCookie;
